import { NgModule } from "@angular/core";
import { CacheModule } from "obscache";
import { NavigationService } from "./navigation/navigation.service";
import { UserService } from "./user/user.service";

@NgModule({
  imports: [
    CacheModule
  ],
  providers: [
    UserService,
    NavigationService
  ]
})
export class ServicesModule {}



// WEBPACK FOOTER //
// ./src/app/common/services/services.module.ts